var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReceiptEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/receipt-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.3327 15.067V9.387C27.3327 4.01367 26.0793 2.66699 21.0393 2.66699H10.9594C5.91935 2.66699 4.66602 4.01367 4.66602 9.387V24.4003C4.66602 27.947 6.6127 28.787 8.9727 26.2537L8.986 26.2403C10.0793 25.0803 11.746 25.1736 12.6927 26.4403L14.0393 28.2403",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.666 9.33301H21.3327",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 14.667H20",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.282 19.6937L19.562 24.4137C19.3754 24.6004 19.202 24.947 19.162 25.2004L18.9087 27.0004C18.8153 27.6537 19.2687 28.1071 19.922 28.0137L21.722 27.7604C21.9753 27.7204 22.3353 27.547 22.5087 27.3604L27.2287 22.6404C28.042 21.8271 28.4287 20.8804 27.2287 19.6804C26.042 18.4937 25.0953 18.8804 24.282 19.6937Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.5996 20.374C23.9996 21.814 25.1196 22.934 26.5596 23.334",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReceiptEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/receipt-edit.d876a2dc.svg";
export { ForwardRef as ReactComponent };